<template>
  <div>
    <div class="warp" v-if="!isMobile">
      <!-- 登录按钮 -->
      <div class="login-email-btn-box" @click="toLoginEamil">
        <img class="email-btn" src="../assets/email-btn.png" />
        <div class="email-text">邮箱登录</div>
      </div>
      <!-- 导航栏 -->
      <div class="title-box" :class="{ scrolled: !isHomeSection }">
        <div class="title">
          <div class="title-text">
            <img src="../assets/logo.png" class="logo-img" />
          </div>
          <div class="title-nav">
            <!-- <div
              v-for="item in navList"
              :key="item.navIndex"
              class="title-nav-item"
              :class="{
                active: activeIndex === item.navIndex,
                'active-b': !isHomeSection && activeIndex === item.navIndex,
              }"
              @click="scrollToSection(item.navIndex)"
            > -->
            <div
              v-for="item in navList"
              :key="item.navIndex"
              class="title-nav-item"
              :class="{
                active: activeIndex === item.navIndex,
                'active-b': activeIndex === item.navIndex,
              }"
              @click="scrollToSection(item.navIndex)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>

      <!-- 第一块 - 轮播图 -->
      <div id="home" class="block1">
        <div
          class="swiper-box"
          @mouseenter="pauseAutoPlay"
          @mouseleave="startAutoPlay"
        >
          <div class="swiper-container">
            <div
              class="swiper-item"
              v-for="(item, index) in bannerList"
              :key="item.bannerIndex"
              :class="{ active: currentSlide === index }"
            >
              <div class="swiper-item-title">{{ item.title }}</div>
              <div class="swiper-item-text">{{ item.text }}</div>
            </div>
          </div>

          <div class="pagination">
            <div
              v-for="(_, index) in bannerList"
              :key="index"
              class="pagination-item"
              :class="{ active: currentSlide === index }"
              @click="setSlide(index)"
            ></div>
          </div>
        </div>
      </div>

      <!-- 一二块中间 -->
      <div class="block2-middle-box">
        <div class="block2-middle">
          <div
            class="block2-item"
            v-for="item in middleItems"
            :key="item.title"
          >
            <img :src="item.icon" class="block2-icon" alt="" />
            <div class="block2-text-box">
              <div class="block2-text-title">{{ item.title }}</div>
              <div class="block2-text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二块 - 业务范围 -->
      <div id="scope" class="block2-box">
        <div class="block2">
          <div class="block2-title">业务范围</div>
          <div class="block2-en-title">Business Scope</div>
          <div class="block2-1-text">
            致力于提供最专业的临床研发创新服务，助力新药研发冲刺
          </div>
          <div class="block2-1-text">
            为医药企业和CRO提供整合的临床研究和创新的综合解决方案，
            打造国内最专业的新药研发服务信息化平台专业化团队，具备专业医学知识和外资企业管理经验。
          </div>

          <div class="block2-business-box">
            <div
              v-for="(business, index) in businessList"
              :key="index"
              class="business-item"
              :class="[
                business.class,
                { [`${business.class}-bg`]: activeBusiness === index },
              ]"
              @mouseover="setActiveBusiness(index)"
            >
              <div
                :class="{
                  'business-title': activeBusiness === index,
                  'business-title-b': activeBusiness !== index,
                }"
              >
                {{ business.title }}
              </div>
              <div
                :class="{
                  'business-line': activeBusiness === index,
                  'business-line-b': activeBusiness !== index,
                }"
              ></div>
              <div class="business-text" v-if="activeBusiness === index">
                <div>
                  {{ business.text1 }}
                </div>
                <div>
                  {{ business.text2 }}
                </div>
                <div>
                  {{ business.text3 }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第三块 - 业务分布 -->
      <div id="distribution" class="block3-box">
        <div class="block3">
          <div class="block3-title">业务分布</div>
          <div class="block3-en-title">Business Distribution</div>

          <div class="full-box">
            <div class="full-box-left">
              <div
                v-for="(item, index) in distributionList"
                :key="index"
                class="block3-left-item"
                :class="{
                  active: activeDistributionIndex === index,
                  'no-bg': activeDistributionIndex !== index,
                }"
                @mouseover="setActiveDistribution(index)"
              >
                <div
                  class="block3-left-item-content"
                  :class="{
                    'with-bg': activeDistributionIndex === index,
                    'without-bg': activeDistributionIndex !== index,
                  }"
                >
                  <div class="block3-left-item-right-title">
                    {{ item.title }}
                  </div>
                  <div class="block3-left-item-right-en-title">
                    {{ item.enTitle }}
                  </div>
                  <transition name="fade">
                    <div
                      v-if="activeDistributionIndex === index"
                      class="block3-left-item-right-text"
                    >
                      {{ item.description }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>

            <div class="full-box-right">
              <transition name="fade" mode="out-in">
                <div :key="activeDistributionIndex" class="block3-right-item">
                  <img
                    class="block3-right-item-img"
                    :src="distributionList[activeDistributionIndex].mapImage"
                  />
                  <div>
                    <div
                      v-for="(area, aIndex) in distributionList[
                        activeDistributionIndex
                      ].areas"
                      :key="aIndex"
                      class="area-section"
                    >
                      <div class="block3-right-item-title">
                        {{ area.region }}
                      </div>
                      <div class="block3-right-item-content">
                        {{ area.cities }}
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <!-- 第四块 - 业务介绍 -->
      <div id="recruitment" class="block4-box">
        <div class="block4">
          <div class="block4-title-box">
            <div v-for="tab in tabs" :key="tab.id" @click="toggle4(tab.id)">
              <div
                class="block4-title"
                :class="{ 'block4-title-active': block4Index === tab.id }"
              >
                {{ tab.title }}
              </div>
              <div class="block4-title-en">{{ tab.enTitle }}</div>
              <div class="block4-title-line-box" v-if="block4Index === tab.id">
                <div class="block4-title-line"></div>
              </div>
            </div>
          </div>
          <div class="block4-title-full-line"></div>
          <div class="block4-content">
            <img
              :src="tabs.find((tab) => tab.id === block4Index)?.image"
              class="block4-img"
            />
          </div>
        </div>
      </div>

      <!-- 第五块 - 数字化解决方案 -->
      <div id="digital" class="block5-box">
        <div class="block5">
          <div class="block5-title">数字化解决方案</div>
          <div class="block5-en-title">Digital Solutions</div>
          <div class="block5-title-tips">
            业务流程优化、运营成本降低、核心竞争力提升
          </div>
          <div class="block5-content">
            <div
              class="block5-item-left"
              @mouseover="activePanel = 1"
              :class="{
                active: activePanel === 1,
                inactive: activePanel === 2,
              }"
            >
              <img
                src="../assets/digital/ai-2.png"
                class="block5-item-img-big"
                v-show="activePanel === 1"
              />
              <img
                src="../assets/digital/ai-1.png"
                class="block5-item-img-small"
                v-show="activePanel === 2"
              />
            </div>
            <div
              class="block5-item-right"
              @mouseover="activePanel = 2"
              :class="{
                active: activePanel === 2,
                inactive: activePanel === 1,
              }"
            >
              <img
                src="../assets/digital/pay-1.png"
                class="block5-item-img-small"
                v-show="activePanel === 1"
              />
              <img
                src="../assets/digital/pay-2.png"
                class="block5-item-img-big"
                v-show="activePanel === 2"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 第六块 - 发展历程（添加动画效果） -->
      <div id="development" class="block6-box" ref="developmentBlock">
        <div class="block6">
          <div class="block6-title">发展历程</div>
          <div class="block6-en-title">Company Development</div>
          <div class="block6-content">
            <div
              v-for="(item, index) in developmentList"
              :key="index"
              class="block6-item"
              :class="`block6-item${index + 1}`"
              :ref="`devItem${index}`"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>

      <!-- 第七块 - 合作伙伴 -->
      <div id="partners" class="block7-box">
        <div class="block7">
          <div class="block7-title">合作伙伴</div>
          <div class="block7-en-title">Partner</div>
          <img src="../assets/partner.png" class="block7-img" />
        </div>
      </div>

      <!-- 第八块 - 加入我们 -->
      <div id="joinUs" class="block8-box">
        <div class="block8">
          <div class="block8-title">加入我们</div>
          <div class="block8-en-title">Join us</div>
          <div class="block8-desc">
            我们致力于为医药研发领域提供专业服务，诚邀有志之士加入团队，共同推动中国药物临床试验发展，为患者带来新的希望。
          </div>
          <div class="block8-card">
            <div
              class="block8-card-header"
              :style="{
                width:
                  joinUsList[activeJoinUsIndex].title.length * 20 + 80 + 'px',
              }"
            >
              {{ joinUsList[activeJoinUsIndex].title }}
            </div>
            <div class="block8-card-body">
              <div class="block8-section">
                <div class="block8-section-icon">
                  <img
                    src="../assets/loc.png"
                    class="block8-section-icon-img"
                  />
                </div>
                <div class="block8-section-right">
                  <div class="block8-section-title">招聘地区</div>
                  <div class="block8-section-content">
                    {{ joinUsList[activeJoinUsIndex].region }}
                  </div>
                </div>
              </div>

              <div class="block8-section">
                <div class="block8-section-icon">
                  <img
                    src="../assets/duty.png"
                    class="block8-section-icon-img"
                  />
                </div>
                <div class="block8-section-right">
                  <div class="block8-section-title">岗位职责</div>
                  <div class="block8-section-content">
                    <div
                      v-for="(item, index) in joinUsList[activeJoinUsIndex]
                        .responsibilities"
                      :key="'r' + index"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="block8-section">
                <div class="block8-section-icon">
                  <img
                    src="../assets/claim.png"
                    class="block8-section-icon-img"
                  />
                </div>
                <div class="block8-section-right">
                  <div class="block8-section-title">任职要求</div>
                  <div class="block8-section-content">
                    <div
                      v-for="(item, index) in joinUsList[activeJoinUsIndex]
                        .requirements"
                      :key="'q' + index"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="block8-pagination">
            <div
              v-for="(_, index) in joinUsList"
              :key="index"
              class="block8-pagination-item"
              :class="{ active: activeJoinUsIndex === index }"
              @click="activeJoinUsIndex = index"
            ></div>
          </div>
        </div>
      </div>

      <!-- 页尾 -->
      <div class="footer-box">
        <div class="footer">
          <div class="footer-up">
            <div
              class="footer-item"
              v-for="(item, index) in footerItems"
              :key="index"
            >
              <div class="fotter-item-title">{{ item.title }}</div>
              <div class="footer-item-content">
                <div
                  v-for="(link, linkIndex) in item.links"
                  :key="linkIndex"
                  @click="handleFooterClick(link, item)"
                >
                  {{ link.text || link }}
                </div>
              </div>
            </div>
            <div
              class="footer-item"
              v-for="(qr, index) in qrCodes"
              :key="'qr' + index"
            >
              <img :src="qr" class="qrcode" />
            </div>
          </div>
          <div class="footer-line"></div>
          <div class="footer-down" @click="toCopyrightWeb">
            津ICP备2024025815号-5 方穹科技（天津）有限公司
          </div>
        </div>
      </div>
      <el-dialog
        :visible.sync="loginDialog"
        width="1400px"
        :before-close="handleClose"
        :show-close="true"
        :custom-class="'login-dialog'"
      >
        <!-- <div>
        <img src="../assets/dialog-logo.png" class="login-dialog-logo" />
        <div class="login-dialog-title-box">
          <div class="dialog-title">Sign In</div>
          <div class="dialog-vice-title">Welcome to log in and use</div>
          <div class="login-dialog-input-box">
            <el-input
              placeholder="请输入邮箱"
              prefix-icon="el-icon-message"
              v-model="email"
            >
            </el-input>
            <el-input
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              v-model="password"
            >
            </el-input>
          </div>
          <div>
            <el-button
              type="primary"
              class="login-dialog-btn"
              @click="login"
            >
              登录
            </el-button>
          </div>
        </div>
      </div> -->
        <iframe
          style="width: 1200px; height: 700px"
          src="//mail.baibosheng.com/"
          frameborder="0"
          sandbox="allow-same-origin allow-scripts allow-forms"
        ></iframe>
      </el-dialog>
    </div>
    <div class="mobile-warp" v-if="isMobile">
      <div class="logo-box-mobile">
        <img
          src="../assets/mobile/mobile-logo.png"
          alt=""
          class="logo-mobile"
        />
        <img
          src="../assets/mobile/drawer.png"
          alt=""
          class="drawer-img"
          @click="openDrawer"
        />
      </div>
      <div class="home-top"></div>
      <div id="home" class="block1-mobile">
        <div
          class="swiper-box-mobile"
          @mouseenter="pauseAutoPlay"
          @mouseleave="startAutoPlay"
        >
          <div class="swiper-container-mobile">
            <div
              class="swiper-item-mobile"
              v-for="(item, index) in bannerList"
              :key="item.bannerIndex"
              :class="{ active: currentSlide === index }"
            >
              <div class="swiper-item-title-mobile">{{ item.title }}</div>
              <div class="swiper-item-text-mobile">{{ item.text }}</div>
            </div>
          </div>

          <div class="pagination-mobile">
            <div
              v-for="(_, index) in bannerList"
              :key="index"
              class="pagination-item-mobile"
              :class="{ active: currentSlide === index }"
              @click="setSlide(index)"
            ></div>
          </div>
        </div>
      </div>
      <div class="block2-mobile">
        <div class="block2-mobile-item">
          <img src="../assets/mobile/duty-icon.png" alt="" class="block2-img" />
          <div class="block2-title">我们的使命</div>
          <div class="block2-text">
            以专业和责任担当，搭建受试者与临床试验的桥梁，推动药物研发进程，为患者带来新的希望。
          </div>
        </div>
        <div style="width: 20%"></div>
        <div class="block2-mobile-item">
          <img
            src="../assets/mobile/target-icon.png"
            alt=""
            class="block2-img"
          />
          <div class="block2-title">我们的愿景</div>
          <div class="block2-text">
            建设专业、智能、高效的受试者服务体系，为中国药物临床试验提供卓越支持，让健康触手可及。
          </div>
        </div>
      </div>
      <div id="scope" class="block3-mobile">
        <div class="block3-mobile-title">业务范围</div>
        <div class="block3-mobile-subtitle">Business Scope</div>
        <div class="block3-mobile-description">
          致力于提供最专业的临床研发创新服务，助力新药研发冲刺 。
        </div>
        <div class="block3-mobile-description">
          为医药企业和CRO提供整合的临床研究和创新的综合解决方案，打造国内最专业的新药研发服务信息化平台专业化团队，具备专业医学知识和外资企业管理经验。
        </div>
        <div class="block3-mobile-item-box">
          <div
            class="block3-mobile-item block3-mobile-item-1"
            @click="showImg(1)"
          >
            <div class="block3-mobile-item-title">招募</div>
            <div class="block3-mobile-item-line"></div>
            <div class="block3-mobile-item-text">
              致确保临床试验顺利进行:保障试验进度精准招募降低...
            </div>
          </div>
          <div
            class="block3-mobile-item block3-mobile-item-2"
            @click="showImg(2)"
          >
            <div class="block3-mobile-item-title">SMO</div>
            <div class="block3-mobile-item-line"></div>
            <div class="block3-mobile-item-text">
              提高临床试验效率:协助 CRO 快速启动临床试验...
            </div>
          </div>
          <div
            class="block3-mobile-item block3-mobile-item-3"
            @click="showImg(3)"
          >
            <div class="block3-mobile-item-title">CRO</div>
            <div class="block3-mobile-item-line"></div>
            <div class="block3-mobile-item-text">
              致通过专业化服务提升研发效率、降低成本、保障合...
            </div>
          </div>
          <div
            class="block3-mobile-item block3-mobile-item-4"
            @click="showImg(4)"
          >
            <div class="block3-mobile-item-title">补偿支付</div>
            <div class="block3-mobile-item-line"></div>
            <div class="block3-mobile-item-text">
              提升受试者体验:及时可靠、保护隐私 优化财务管理:...
            </div>
          </div>
        </div>
      </div>
      <div
        id="distribution"
        class="block4-mobile"
        @click="scrollTo('distribution')"
      >
        <div class="block3-mobile-title">业务分布</div>
        <div class="block3-mobile-subtitle">Business Distribution</div>
        <div class="mobile-carousel">
          <div
            class="carousel-viewport"
            @touchstart="onTouchStart"
            @touchmove="onTouchMove"
            @touchend="onTouchEnd"
          >
            <div class="carousel-inner" :style="carouselStyle">
              <div
                v-for="(img, index) in loopImgList"
                :key="index"
                class="carousel-item"
                :ref="index === 0 ? 'carouselItem' : null"
              >
                <!-- <img :src="img" class="distribution-img" /> -->
                <div class="distribution-item-box">
                  <template v-if="getRealByLoopIndex(index) === 0">
                    <div class="distribution-item-title">招募</div>
                    <div class="distribution-item-subtitle">Recruitment</div>
                    <div class="distribution-item-description">
                      以受试者权益与安全为核心，有力保障了临床试验的顺利完成，从而推动新药上市。
                    </div>
                    <div class="distribution-item-map-box">
                      <img
                        src="../assets/mobile/distribution-1-map.png"
                        alt=""
                        class="distribution-item-map"
                      />
                    </div>
                    <div class="distribution-item-point-box">
                      <div>
                        <span class="distribution-item-point">华东区：</span
                        >上海、江苏
                      </div>
                      <div>
                        <span class="distribution-item-point">华北区：</span
                        >北京、天津
                      </div>
                    </div>
                    <div class="distribution-item-point-box">
                      <div>
                        <span class="distribution-item-point">东北区：</span
                        >黑龙江、辽宁
                      </div>
                      <div>
                        <span class="distribution-item-point">西南区：</span
                        >四川
                      </div>
                    </div>
                    <div
                      class="distribution-item-point-box distribution-item-point-box-last"
                    >
                      <div>
                        <span class="distribution-item-point">西北区：</span
                        >陕西
                      </div>
                      <div>
                        <span class="distribution-item-point">华南区：</span>
                        <el-popover
                          placement="top"
                          title=""
                          width="200"
                          trigger="manual"
                          class="popover-ref"
                          :value="activePopover === '1'"
                          @input="(val) => handlePopoverChange(val, '1')"
                          content="河南、湖北、湖南、广东"
                        >
                          <div
                            slot="reference"
                            @click.stop.prevent="togglePopover('1')"
                          >
                            河南、湖北...
                          </div>
                        </el-popover>
                      </div>
                    </div>
                  </template>
                  <template v-if="getRealByLoopIndex(index) === 1">
                    <div class="distribution-item-title">SMO</div>
                    <div class="distribution-item-subtitle">
                      Site Management Organization
                    </div>
                    <div class="distribution-item-description">
                      受试者补偿第三方支付覆盖全国,专精临床试验现场与1-IV期受试者全方位管理。
                    </div>
                    <div class="distribution-item-map-box">
                      <img
                        src="../assets/mobile/distribution-2-map.png"
                        alt=""
                        class="distribution-item-map"
                      />
                    </div>
                    <div class="distribution-item-point-box">
                      <div>
                        <span class="distribution-item-point">西南区：</span>
                        <el-popover
                          placement="top"
                          title=""
                          width="200"
                          trigger="manual"
                          class="popover-ref"
                          :value="activePopover === '2'"
                          @input="(val) => handlePopoverChange(val, '2')"
                          content="重庆、四川、贵州、云南、西藏"
                        >
                          <div
                            slot="reference"
                            @click.stop.prevent="togglePopover('2')"
                          >
                            重庆、四川...
                          </div>
                        </el-popover>
                      </div>
                      <div>
                        <span class="distribution-item-point">华东区：</span>
                        <el-popover
                          placement="top"
                          title=""
                          width="200"
                          trigger="manual"
                          class="popover-ref"
                          :value="activePopover === '3'"
                          @input="(val) => handlePopoverChange(val, '3')"
                          content="上海、江苏、浙江、安徽、福建、江西、山东"
                        >
                          <div
                            slot="reference"
                            @click.stop.prevent="togglePopover('3')"
                          >
                            上海、江苏...
                          </div>
                        </el-popover>
                      </div>
                    </div>
                    <div class="distribution-item-point-box">
                      <div>
                        <span class="distribution-item-point">东北区：</span
                        ><el-popover
                          placement="top"
                          title=""
                          width="200"
                          trigger="manual"
                          class="popover-ref"
                          :value="activePopover === '4'"
                          @input="(val) => handlePopoverChange(val, '4')"
                          content="黑龙江、辽宁、吉林"
                        >
                          <div
                            slot="reference"
                            @click.stop.prevent="togglePopover('4')"
                          >
                            黑龙江、吉林...
                          </div>
                        </el-popover>
                      </div>
                      <div>
                        <span class="distribution-item-point">华南区：</span>
                        <el-popover
                          placement="top"
                          title=""
                          width="200"
                          trigger="manual"
                          class="popover-ref"
                          :value="activePopover === '5'"
                          @input="(val) => handlePopoverChange(val, '5')"
                          content="河南、湖北、湖南、广东"
                        >
                          <div
                            slot="reference"
                            @click.stop.prevent="togglePopover('5')"
                          >
                            河南、湖北...
                          </div>
                        </el-popover>
                      </div>
                    </div>
                    <div
                      class="distribution-item-point-box distribution-item-point-box-last"
                    >
                      <div>
                        <span class="distribution-item-point">西北区：</span>
                        <el-popover
                          placement="top"
                          title=""
                          width="200"
                          trigger="manual"
                          class="popover-ref"
                          :value="activePopover === '6'"
                          @input="(val) => handlePopoverChange(val, '6')"
                          content="陕西、甘肃、青海、宁夏、新疆"
                        >
                          <div
                            slot="reference"
                            @click.stop.prevent="togglePopover('6')"
                          >
                            陕西、甘肃...
                          </div>
                        </el-popover>
                      </div>
                    </div>
                  </template>
                  <template v-if="getRealByLoopIndex(index) === 2">
                    <div class="distribution-item-title">CRO</div>
                    <div class="distribution-item-subtitle">
                      Contract Research Organization
                    </div>
                    <div class="distribution-item-description">
                      通过专业化服务提升研发效率、降低成本、保障合规性，助力新药或医疗器械更快推进研发及上市进程。
                    </div>
                    <div class="distribution-item-map-box">
                      <img
                        src="../assets/mobile/distribution-3-map.png"
                        alt=""
                        class="distribution-item-map"
                      />
                    </div>
                    <div class="distribution-item-point-box">
                      <div>
                        <span class="distribution-item-point">华东区：</span
                        >山东
                      </div>
                    </div>
                    <div class="distribution-item-point-box">
                      <div>
                        <span class="distribution-item-point">西北区：</span
                        >陕西
                      </div>
                    </div>
                  </template>
                </div>
                <!-- <div
                  class="distribution-item-box"
                  v-show="realIndex === 1"
                ></div> -->
                <!-- <div
                  class="distribution-item-box"
                  v-show="realIndex === 2"
                ></div> -->
              </div>
              <!-- <div class="carousel-item carousel-end-holder"></div> -->
            </div>
            <!-- 指示点 -->
            <div class="carousel-indicators">
              <span
                v-for="(_, index) in imgList"
                :key="index"
                :class="[
                  'indicator',
                  {
                    active:
                      currentIndex - 1 === index ||
                      (currentIndex === 0 && index === imgList.length - 1),
                  },
                ]"
                @click="goTo(index)"
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div id="intro" class="block5-mobile">
        <div class="block3-mobile-title">业务介绍</div>
        <div class="block3-mobile-subtitle">Business Introduction</div>

        <div class="block5-mobile-tabs">
          <div
            class="block5-mobile-tabs-item"
            v-for="(tab, index) in mobileTabs"
            :key="tab.key"
            @click="activeTab = index"
          >
            <div
              class="block5-mobile-tabs-item-title"
              :class="{ 'title-active': activeTab === index }"
            >
              {{ tab.label }}
            </div>
            <div
              class="block5-mobile-tabs-item-down-line"
              :class="{ 'line-active': activeTab === index }"
            ></div>
          </div>
        </div>
        <!-- 内容区域 -->
        <!-- <img
          :key="activeTab"
          :src="mobileTabs[activeTab].img"
          class="introduction-img"
        /> -->
        <div class="intro-item-box" v-show="activeTab === 0">
          <div class="intro-item-1st">
            提供I-IV期临床试验受试者招募解决方案，成为新药研发的催化剂，保障试验质量与进度。
          </div>
          <div class="intro-item-bottom-title-box">
            <div class="intro-item-bottom-title">我们的服务</div>
            <div class="intro-item-bottom-line"></div>
          </div>
          <img
            src="../assets/mobile/introduction-1-1.png"
            alt=""
            class="intro-item-1-img"
          />
          <div class="intro-item-bottom-title-box">
            <div class="intro-item-bottom-title">重点覆盖适应症</div>
            <div class="intro-item-bottom-line"></div>
          </div>
          <div class="intro-item-1-dis">
            <div class="intro-item-1-item">
              <div class="intro-item-1-item-title">肿瘤</div>
              <div class="intro-item-1-item-text">
                消化肿瘤，妇科肿瘤，头颈肿瘤，胸部肿瘤，泌尿肿瘤，皮肤肿瘤，血液肿瘤
              </div>
            </div>
            <div class="intro-item-1-item">
              <div class="intro-item-1-item-title">非肿瘤</div>
              <div class="intro-item-1-item-text">
                风湿免疫，内分泌，心血管，皮肤科，呼吸科，神经科，消化科
              </div>
            </div>
          </div>
          <div class="intro-item-bottom-title-box">
            <div class="intro-item-bottom-title">服务优势</div>
            <div class="intro-item-bottom-line"></div>
          </div>
          <div class="intro-item-bottom-item-box">
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box">
                <img
                  src="../assets/mobile/intro-icon-1.png"
                  alt=""
                  class="intro-icon-img"
                />
              </div>
              <div class="intro-item-bottom-item-text">自建优势患者数据库</div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box"></div>
              <div class="intro-item-bottom-item-text-large">
                患者库资源目前累30000余例
              </div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box">
                <img
                  src="../assets/mobile/intro-icon-2.png"
                  alt=""
                  class="intro-icon-img"
                />
              </div>
              <div class="intro-item-bottom-item-text">区域医院深度覆盖</div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box"></div>
              <div class="intro-item-bottom-item-text-large">
                覆盖医院及相关专家（2000+）
              </div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box">
                <img
                  src="../assets/mobile/intro-icon-3.png"
                  alt=""
                  class="intro-icon-img"
                />
              </div>
              <div class="intro-item-bottom-item-text">政府教育项目合作</div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box"></div>
              <div class="intro-item-bottom-item-text-large">
                社区长期合作-科普讲座
              </div>
            </div>
          </div>
        </div>
        <div class="intro-item-box" v-show="activeTab === 1">
          <div class="intro-item-1st">
            提供一站式全流程服务，分阶段模块化服务，建立严格质量管理体系，把控项目的质量与进度。
          </div>
          <img
            src="../assets/mobile/introduction-2-inner.png"
            alt=""
            class="intro-item-2-img"
          />
          <div class="intro-item-bottom-title-box">
            <div class="intro-item-bottom-title">业务优势</div>
            <div class="intro-item-bottom-line"></div>
          </div>
          <div class="intro-item-bottom-item-box">
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box">
                <img
                  src="../assets/mobile/intro-icon-4.png"
                  alt=""
                  class="intro-icon-img"
                />
              </div>
              <div class="intro-item-bottom-item-text">体系完善</div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box"></div>
              <div class="intro-item-bottom-item-text-large">
                标准化SOP、内部QC三级质控、项目管理体系，完善的培训体系等
              </div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box">
                <img
                  src="../assets/mobile/intro-icon-5.png"
                  alt=""
                  class="intro-icon-img"
                />
              </div>
              <div class="intro-item-bottom-item-text">合作密切</div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box"></div>
              <div class="intro-item-bottom-item-text-large">
                优良的机构关系和科室关系，40+战略合作医院，60+合作科室
              </div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box">
                <img
                  src="../assets/mobile/intro-icon-6.png"
                  alt=""
                  class="intro-icon-img"
                />
              </div>
              <div class="intro-item-bottom-item-text">满意服务</div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box"></div>
              <div class="intro-item-bottom-item-text-large">
                良好的服务体验，年度客户满意度100%
              </div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box">
                <img
                  src="../assets/mobile/intro-icon-7.png"
                  alt=""
                  class="intro-icon-img"
                />
              </div>
              <div class="intro-item-bottom-item-text">经验丰富</div>
            </div>
            <div class="intro-item-bottom-item">
              <div class="intro-icon-box"></div>
              <div class="intro-item-bottom-item-text-large">
                丰富的I-II期项目经验和肿瘤经验近百项项目经验，以抗感染和肿瘤项目为主
              </div>
            </div>
          </div>
        </div>
        <div class="intro-item-box intro-item-3-box" v-show="activeTab === 2">
          <img
            src="../assets/mobile/introduction-3.png"
            alt=""
            class="introduction-img"
          />
        </div>
      </div>
      <div id="solution" class="block6-mobile">
        <div class="block3-mobile-title">数字化解决方案</div>
        <div class="block3-mobile-subtitle">Recruitment Operations</div>
        <div class="block3-mobile-description">
          业务流程优化、运营成本降低、核心竞争力提升
        </div>
        <div class="solu-item mb12">
          <div class="solu-item-title-box">
            <img
              src="../assets/mobile/rec-title-icon-1.png"
              alt=""
              class="rec-title-icon-img"
            />
            <div class="solu-item-title">临研智慧平台</div>
          </div>
          <div class="solu-line"></div>
          <div class="solu-text">
            专为招募企业和患者打造的全流程智能服务平台，通过“运营端-企业端-患者端”三端协同模式，以AI大模型技术为驱动，实现病案智能解析与项目精准匹配，革新传统临床试验招募工作流，提升人员效能。
          </div>
          <img
            src="../assets/mobile/operations-1-1.png"
            alt=""
            class="operation-img"
          />
        </div>
        <div class="solu-item mb20">
          <div class="solu-item-title-box">
            <img
              src="../assets/mobile/rec-title-icon-2.png"
              alt=""
              class="rec-title-icon-img"
            />
            <div class="solu-item-title">临研界受试者补偿支付平台</div>
          </div>
          <div class="solu-line"></div>
          <div class="solu-text-box">
            <div>·提升效率、即用即付</div>
            <div>·数据脱敏、安全隐私保护</div>
          </div>
          <div class="solu-text-box">
            <div>·线上业务流、多角色协同</div>
            <div>·独立账户、安全可循</div>
          </div>
          <img
            src="../assets/mobile/operations-2-1.png"
            alt=""
            class="operation-img"
          />
        </div>
      </div>
      <div id="history" class="block7-mobile">
        <div class="block3-mobile-title">发展历程</div>
        <div class="block3-mobile-subtitle">Company Development</div>
        <div class="time-line-box">
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="activity.timestamp"
              :color="activity.color"
            >
              {{ activity.content }}
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <div id="partner" class="block8-mobile">
        <div class="block3-mobile-title">合作伙伴</div>
        <div class="block3-mobile-subtitle">Partner</div>
        <img src="../assets/mobile/partner.png" alt="" class="operation-img" />
      </div>
      <div id="joinUs" class="block10-mobile">
        <div class="block3-mobile-title">加入我们</div>
        <div class="block3-mobile-subtitle">Join us</div>
        <div class="block10-mobile-desc">
          我们致力于为医药研发领域提供专业服务，诚邀有志之士加入团队，共同推动中国药物临床试验发展，为患者带来新的希望。
        </div>
        <div class="block10-mobile-accordion">
          <div
            v-for="(item, index) in joinUsList"
            :key="index"
            class="block10-mobile-accordion-item"
          >
            <div
              class="block10-mobile-accordion-header"
              @click="toggleMobileJoinUs(index)"
            >
              <span class="block10-mobile-accordion-title">{{ item.title }}</span>
              <img
                :src="activeMobileJoinUsIndex === index ? openIcon : closeIcon"
                class="block10-mobile-accordion-icon"
              />
            </div>
            <div
              class="block10-mobile-accordion-body"
              :class="{ 'is-open': activeMobileJoinUsIndex === index }"
            >
              <div class="block10-mobile-section">
                <div class="block10-mobile-section-icon">
                  <img src="../assets/loc.png" width="12" height="12" />
                </div>
                <div class="block10-mobile-section-title">招聘地区</div>
              </div>
              <div class="block10-mobile-section-content">
                {{ item.region }}
              </div>

              <div class="block10-mobile-section">
                <div class="block10-mobile-section-icon">
                  <img src="../assets/duty.png" width="12" height="12" />
                </div>
                <div class="block10-mobile-section-title">岗位职责</div>
              </div>
              <div class="block10-mobile-section-content">
                <div
                  v-for="(resp, rIndex) in item.responsibilities"
                  :key="'r' + rIndex"
                  class="block10-mobile-item"
                >
                  {{ resp }}
                </div>
              </div>

              <div class="block10-mobile-section">
                <div class="block10-mobile-section-icon">
                  <img src="../assets/claim.png" width="12" height="12" />
                </div>
                <div class="block10-mobile-section-title">任职要求</div>
              </div>
              <div class="block10-mobile-section-content">
                <div
                  v-for="(req, qIndex) in item.requirements"
                  :key="'q' + qIndex"
                  class="block10-mobile-item"
                >
                  {{ req }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="contact" class="block9-mobile">
        <div class="menu-box">
          <div class="menu-item">
            <div class="menu-title" @click="scrollTo('home')">业务说明</div>
            <div class="menu-text" @click="scrollTo('scope')">业务范围</div>
            <div class="menu-text" @click="scrollTo('distribution')">
              业务分布
            </div>
            <div class="menu-text" @click="scrollTo('intro')">业务介绍</div>
            <div class="menu-text" @click="scrollTo('solution')">
              数字化解决方案
            </div>
          </div>
          <div class="menu-item">
            <div class="menu-title" @click="scrollTo('history')">关于方穹</div>
            <div class="menu-text" @click="scrollTo('partner')">发展历程</div>
            <div class="menu-text" @click="scrollTo('contact')">合作伙伴</div>
            <div class="menu-text" @click="scrollTo('joinUs')">加入我们</div>
          </div>
          <div class="menu-item-3">
            <div class="menu-title">联系我们</div>
            <div class="menu-text">详细地址：</div>
            <div class="menu-text">
              天津市南开区科研西路天津科技广场6-1-0401（天开园）
            </div>
            <div class="menu-text">加入我们：</div>
            <div class="menu-text">HR@fqmed.cn</div>
            <div class="menu-text">业务咨询：</div>
            <div class="menu-text">business@fqmed.cn</div>
            <div class="menu-text">意见反馈：</div>
            <div class="menu-text">legal@fqmed.cn</div>
            <div class="qrcode-box">
              <img src="../assets/ai-qrcode.png" alt="" class="qrcode-img" />
              <img src="../assets/jie-qrcode.png" alt="" class="qrcode-img" />
            </div>
          </div>
        </div>
        <div class="menu-line"></div>
        <div class="copyright-text" @click="toCopyrightWeb">
          津ICP备2024025815号-5 方穹科技（天津）有限公司
        </div>
      </div>
      <el-drawer
        title="我是标题"
        :visible.sync="drawer"
        :with-header="false"
        show-close
        custom-class="drawer-custom-class"
        size="80%"
      >
        <div class="drawer-box">
          <div class="drawer-header">
            <img
              src="../assets/mobile/mobile-logo.png"
              alt=""
              class="logo-mobile"
            />
            <div class="close-icon" @click="closeDrawer">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div class="drawer-content">
            <div class="link-item" @click="scrollTo('home')">首页</div>
            <div class="drawer-long-line"></div>
            <div class="link-item" @click="toggleCollapse('business')">
              <div>业务说明</div>
              <div>
                <i
                  :class="
                    activeCollapse === 'business'
                      ? 'el-icon-minus'
                      : 'el-icon-plus'
                  "
                ></i>
              </div>
            </div>
            <div class="drawer-long-line"></div>
            <div
              class="link-item-inner"
              :class="{ open: activeCollapse === 'business' }"
            >
              <div class="link-item-inner-text" @click="scrollTo('scope')">
                业务范围
              </div>
              <div class="link-item-inner-line"></div>

              <div
                class="link-item-inner-text"
                @click="scrollTo('distribution')"
              >
                业务分布
              </div>
              <div class="link-item-inner-line"></div>

              <div class="link-item-inner-text" @click="scrollTo('intro')">
                业务介绍
              </div>
              <div class="link-item-inner-line"></div>

              <div class="link-item-inner-text" @click="scrollTo('solution')">
                数字化解决方案
              </div>
              <div class="link-item-inner-line"></div>
            </div>
            <div class="link-item" @click="toggleCollapse('about')">
              <div>关于方穹</div>
              <div>
                <i
                  :class="
                    activeCollapse === 'about'
                      ? 'el-icon-minus'
                      : 'el-icon-plus'
                  "
                ></i>
              </div>
            </div>
            <div class="drawer-long-line"></div>
            <div
              class="link-item-inner"
              :class="{ open: activeCollapse === 'about' }"
            >
              <div class="link-item-inner-text" @click="scrollTo('history')">
                发展历程
              </div>
              <div class="link-item-inner-line"></div>

              <div class="link-item-inner-text" @click="scrollTo('partner')">
                合作伙伴
              </div>
              <div class="link-item-inner-line"></div>

              <div class="link-item-inner-text" @click="scrollTo('joinUs')">
                加入我们
              </div>
              <div class="link-item-inner-line"></div>
            </div>
            <div class="link-item" @click="scrollTo('contact')">
              <div>联系我们</div>
            </div>
            <div class="drawer-long-line"></div>
          </div>
        </div>
      </el-drawer>
      <el-dialog
        :visible.sync="imgShow"
        width="90%"
        :show-close="false"
        center
        custom-class="img-dialog-box"
      >
        <div class="img-dialog">
          <img
            src="../assets/mobile/scope-1.png"
            alt=""
            class="dialog-img"
            v-if="isPic == 1"
          />
          <img
            src="../assets/mobile/scope-2.png"
            alt=""
            class="dialog-img"
            v-if="isPic == 2"
          />
          <img
            src="../assets/mobile/scope-3.png"
            alt=""
            class="dialog-img"
            v-if="isPic == 3"
          />
          <img
            src="../assets/mobile/scope-4.png"
            alt=""
            class="dialog-img"
            v-if="isPic == 4"
          />
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "homePage",
  data() {
    return {
      isMobile: false,
      openIcon: require("../assets/open.png"),
      closeIcon: require("../assets/close.png"),
      navList: [
        { name: "首页", navIndex: "home" },
        { name: "业务范围", navIndex: "scope" },
        { name: "业务分布", navIndex: "distribution" },
        { name: "业务介绍", navIndex: "recruitment" },
        { name: "数字化方案", navIndex: "digital" },
        { name: "发展历程", navIndex: "development" },
        { name: "合作伙伴", navIndex: "partners" },
        { name: "加入我们", navIndex: "joinUs" },
      ],
      bannerList: [
        {
          title: "专业研创 新药冲刺",
          text: "提供专业的临床研发创新服务，助力新药研发冲刺",
          bannerIndex: "1",
        },
        {
          title: "创新技术 精准医疗",
          text: "运用前沿技术推动精准医疗发展，改善患者治疗效果",
          bannerIndex: "2",
        },
        {
          title: "全球合作 健康未来",
          text: "携手全球合作伙伴，共同创造更健康的未来",
          bannerIndex: "3",
        },
      ],
      middleItems: [
        {
          icon: require("../assets/people-icon.png"),
          title: "我们的使命",
          text: "以专业和责任担当，搭建受试者与临床试验的桥梁，推动药物研发进程，为患者带来新的希望。",
        },
        {
          icon: require("../assets/target-icon.png"),
          title: "我们的愿景",
          text: "建设专业、智能、高效的受试者服务体系，为中国药物临床试验提供卓越支持，让健康触手可及。",
        },
      ],
      businessList: [
        {
          class: "business-recruit",
          title: "招募",
          text1: "确保临床试验顺利进行:保障试验进度、",
          text2: "精准招募降低 CRO 成本和风险:节约时间成本、",
          text3: "降低风险增强 CRO 的竞争力:提供增值服务、建立合作优执。",
        },
        {
          class: "business-smo",
          title: "SMO",
          text1: "提高临床试验效率:协助 CRO 快速启动临床试验",
          text2: "提升临床试验质量:规范、专业数据收集和管理",
          text3: "降低临床试验成本:减少 CRO 人力投入、降低风险",
        },
        {
          class: "business-cro",
          title: "CRO",
          text1:
            "通过专业化服务提升研发效率、降低成本、保障合规性，助力新药或医疗器械更快推进研发及上市进程。",
          text2: "",
          text3: "",
        },
        {
          class: "business-pay",
          title: "补偿支付",
          text1: "提升受试者体验:及时可靠、保护隐私",
          text2: "优化财务管理:简化流程、控制预算",
          text3: "确保合规性:减少合规风险，审计与追溯",
        },
      ],
      distributionList: [
        {
          title: "招募",
          enTitle: "Recruitment",
          description: "以受试者为核心，保障了临床试验的顺利完成，推动新药上市",
          mapImage: require("../assets/distribution/recruit-map.png"),
          areas: [
            { region: "华北区", cities: "北京、天津" },
            { region: "东北区", cities: "黑龙江、辽宁" },
            { region: "华南区", cities: "河南、湖北、湖南、广东" },
            { region: "华东区", cities: "上海、江苏" },
            { region: "西北区", cities: "陕西" },
            { region: "西南区", cities: "四川" },
          ],
        },
        {
          title: "SMO",
          enTitle: "Site Management Organization",
          description:
            "受试者补偿第三方支付覆盖全国,专精临床试验现场与1-IV期受试者全方位管理",
          mapImage: require("../assets/distribution/smo-map.png"),
          areas: [
            { region: "东北区", cities: "辽宁、吉林、黑龙江" },
            { region: "华南区", cities: "河南、湖北、湖南、广东" },
            {
              region: "华东区",
              cities: "上海、江苏、浙江、安徽、 福建、江西、山东",
            },
            { region: "西北区", cities: "陕西、甘肃、青海、宁夏、新疆" },
            { region: "西南区", cities: "重庆、四川、贵州、云南、西藏" },
          ],
        },
        {
          title: "CRO",
          enTitle: "Contract Research Organization",
          description:
            "通过专业化服务提升研发效率、降低成本、保障合规性，助力新药或医疗器械更快推进研发及上市进程。",
          mapImage: require("../assets/distribution/cro-map.png"),
          areas: [
            { region: "华东区", cities: "山东" },
            { region: "西北区", cities: "陕西" },
          ],
        },
      ],
      tabs: [
        {
          id: 1,
          title: "招募",
          enTitle: "Business Recruitment",
          image: require("../assets/plan/recruit-c.png"),
        },
        {
          id: 2,
          title: "SMO",
          enTitle: "Site Management Organization",
          image: require("../assets/plan/smo.png"),
        },
        {
          id: 3,
          title: "CRO",
          enTitle: "Contract Research Organization",
          image: require("../assets/plan/cro.png"),
        },
      ],
      footerItems: [
        {
          title: "业务说明",
          links: [
            { text: "业务范围", section: "scope" },
            { text: "业务分布", section: "distribution" },
            { text: "业务介绍", section: "recruitment" },
            { text: "数字化解决方案", section: "digital" },
          ],
        },
        {
          title: "关于方穹",
          links: [
            { text: "发展历程", section: "development" },
            { text: "合作伙伴", section: "partners" },
            { text: "加入我们", section: "joinUs" },
          ],
        },
        {
          title: "联系我们",
          links: [
            {
              text: "详细地址：天津市南开区科研西路天津科技广场6-1-0401（天开园）",
            },
            { text: "加入我们：HR@fqmed.cn" },
            { text: "业务咨询：business@fqmed.cn" },
            { text: "意见反馈：legal@fqmed.cn" },
          ],
        },
      ],
      qrCodes: [
        require("../assets/ai-qrcode.png"),
        require("../assets/jie-qrcode.png"),
      ],
      developmentList: [
        "方穹医药公司于天津成立，完成天使轮融资",
        "拓展业务覆盖山东、 广东、黑龙江、四川、河南等地",
        "方穹科技入驻天开园 探索打造AI智能临床研发大数据平台",
        "完成天使+轮融资加速业务布局",
      ],
      activeIndex: "home",
      currentSlide: 0,
      autoPlayInterval: null,
      activeBusiness: 0,
      activeDistributionIndex: 0,
      block4Index: 1,
      isHomeSection: true,
      activePanel: 1,
      developmentAnimated: false,
      loginDialog: false,
      email: "",
      password: "",
      currentIndex: 1,
      startX: 0,
      deltaX: 0,
      itemWidth: 0,
      imgList: [
        require("@/assets/mobile/distribution-1.png"),
        require("@/assets/mobile/distribution-2.png"),
        require("@/assets/mobile/distribution-3.png"),
      ],
      isResetting: false,
      activeTab: 0,
      mobileTabs: [
        {
          key: "recruit",
          label: "招募",
          img: require("@/assets/mobile/introduction-1.png"),
        },
        {
          key: "smo",
          label: "SMO",
          img: require("@/assets/mobile/introduction-2.png"),
        },
        {
          key: "cro",
          label: "CRO",
          img: require("@/assets/mobile/introduction-3.png"),
        },
      ],
      activities: [
        {
          content: "2022年5月",
          timestamp: "方穹医药公司于天津成立，完成天使轮融资",
          color: "#1A70D5",
        },
        {
          content: "2023年12月",
          timestamp: "拓展业务覆盖山东、 广东、黑龙江、四川、河南等地",
          color: "#1A70D5",
        },
        {
          content: "2024年1月",
          timestamp: "方穹科技入驻天开园探索打造AI智能临床研发大数据平台",
          color: "#1A70D5",
        },
        {
          content: "2024年7月",
          timestamp: "完成天使+轮融资加速业务布局",
          color: "#1A70D5",
        },
      ],
      drawer: false,
      activeCollapse: "",
      imgShow: false,
      isPic: 1,
      activePopover: null,
      activeJoinUsIndex: 0,
      activeMobileJoinUsIndex: 0,
      joinUsList: [
        {
          title: "方穹医药-项目PM",
          region: "全国",
          responsibilities: [
            "1. 严格遵循GCP及药品临床研究相关法规要求，主导第三方招募类临床项目的全流程合规管理，确保项目执行符合行业规范；",
            "2. 建立与CRO机构的常态化沟通机制，实时跟进项目进度、质量及风险，及时向管理层汇报关键节点与问题解决方案；",
            "3. 负责患者招募的全流程把控，包括招募方案设计、病历资料审核、入组标准验证，确保入组患者符合临床研究要求；",
            "4. 统筹项目相关文件的整理、归档与版本管理，建立标准化文档体系，保障资料可追溯性与完整性；",
            "5. 协助组织项目启动会、中期评估会等关键会议，推动跨部门协作，确保项目按计划落地。",
          ],
          requirements: [
            "1. 医学、药学或相关专业本科及以上学历，具备扎实的医药专业知识基础；",
            "2. 已接受ICH-GCP、中国GCP及相关临床研究法规的系统培训，熟悉临床研究全流程合规要求；",
            "3. 具备优秀的跨方沟通协调能力与时间管理能力，能高效对接CRO、研究中心及内部团队，推动项目进度；",
            "4. 接受因项目需求产生的出差安排，能适应多项目并行的工作节奏；",
            "5. 工作严谨细致，具备较强的风险意识与问题解决能力，能独立处理项目执行中的合规风险与突发问题。",
          ],
        },
        {
          title: "方穹医药-受试者招募岗位",
          region: "全国",
          responsibilities: [
            "1. 完成招募任务，协助研究者招募患者入组；",
            "2. 开展学术推广会、患教会以提高项目入组；",
            "3. 及时上报筛选或入组的患者，确保资料完整、信息真实、版本正确、不超时限等基本要求；",
            "4. 普及学术知识，树立良好的公司形象，如拜访医生、开展学术推广、患者教育等。",
          ],
          requirements: [
            "1. 本科(大专)及以上学历，医药护相关专业；",
            "2. 具备招募/医药代表/市场推广/患教经验的优先考虑;",
            "3. 有较强的沟通能力和抗压能力，良好的时间管理能力，良好的问题分析与解决能力。",
          ],
        },
        {
          title: "方穹医药-临床协调员",
          region: "全国",
          responsibilities: [
            "将参与临床试验全阶段，作为临床研究的多面手，协助研究者和申办方顺利完成临床试验，包括但不限于：",
            "1. 协助完成临床试验项目的资料收集、整理和归档管理；",
            "2. 协助临床试验在医院开展时的受试者筛选入组工作；",
            "3. 协助试验标本的采集、处理、保存和运送工作；",
            "4. 协助研究者填写病例报告表；",
            "5. 协助研究者跟踪受试者定期随访；",
            "6. 协助研究者完成临床试验的其他相关工作；"
          ],
          requirements: [
            "1. 医学、药学、护理等临床医药相关专业背景本科（大专）及以上学历；",
            "2. 良好英文能力、有英语四、六级证书优先；",
            "3. 3年左右全职CRC经验，可独立承接项目；",
            "4. 了解临床试验方法、有关法律、法规的培训，拥有GCP证书；",
            "5. 具有亲和力、正面思维和较强的情绪管理能力；",
            "6. 工作积极主动，责任心强，具备良好的沟通、应变及自我学习能力。",
          ],
        },
      ],
    };
  },
  computed: {
    realIndex() {
      const len = this.imgList.length;
      if (this.currentIndex === 0) return len - 1;
      if (this.currentIndex === len + 1) return 0;
      return this.currentIndex - 1;
    },
    carouselStyle() {
      const distance = this.itemWidth + 15;
      const x = -this.currentIndex * distance + this.deltaX;

      return {
        transform: `translate3d(${x}px, 0, 0)`,
        transition: this.isResetting ? "none" : "transform 0.3s ease",
      };
    },
    loopImgList() {
      if (this.imgList.length === 0) return [];
      return [
        this.imgList[this.imgList.length - 1], // 最后一张（头）
        ...this.imgList,
        this.imgList[0], // 第一张（尾）
      ];
    },
  },
  mounted() {
    this.checkDevice();
    window.addEventListener("resize", this.checkDevice);
    this.startAutoPlay();
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();

    // 添加发展历程区块的滚动监听
    window.addEventListener("scroll", this.checkDevelopmentVisibility);
    // 初始检查一次
    this.$nextTick(() => {
      this.checkDevelopmentVisibility();
      const refs = this.$refs.carouselItem;
      const el = Array.isArray(refs) ? refs[0] : refs;

      if (el instanceof HTMLElement) {
        const style = window.getComputedStyle(el);
        const marginRight = parseFloat(style.marginRight);
        this.itemWidth = el.offsetWidth + marginRight;
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkDevice);
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("scroll", this.checkDevelopmentVisibility);
  },
  methods: {
    toCopyrightWeb() {
      window.open("https://beian.miit.gov.cn", "_blank");
    },
    // 点击开 / 关
    togglePopover(key) {
      this.activePopover = this.activePopover === key ? null : key;
    },

    // 点击空白关闭
    handlePopoverChange(visible, key) {
      if (!visible && this.activePopover === key) {
        this.activePopover = null;
      }
    },

    // 轮播 / 滑动时调用
    closeAllPopovers() {
      this.activePopover = null;
    },
    toggleMobileJoinUs(index) {
      this.activeMobileJoinUsIndex = this.activeMobileJoinUsIndex === index ? -1 : index;
    },
    getRealByLoopIndex(loopIndex) {
      const len = this.imgList.length;

      if (loopIndex === 0) return len - 1;
      if (loopIndex === len + 1) return 0;
      return loopIndex - 1;
    },
    // 以下是移动端方法
    showImg(e) {
      this.imgShow = true;
      this.isPic = e;
    },
    toggleCollapse(key) {
      // 已展开 → 收起
      if (this.activeCollapse === key) {
        this.activeCollapse = "";
      } else {
        this.activeCollapse = key;
      }
    },
    scrollTo(id) {
      this.drawer = false; // 先关闭抽屉
      this.activeCollapse = "";

      this.$nextTick(() => {
        const el = document.getElementById(id);
        if (!el) return;

        const headerHeight = 50; // 顶部 logo 高度
        const top =
          el.getBoundingClientRect().top + window.pageYOffset - headerHeight;

        window.scrollTo({
          top,
          behavior: "smooth",
        });
      });
    },
    closeDrawer() {
      this.drawer = false;
    },
    openDrawer() {
      this.drawer = true;
    },
    onTouchStart(e) {
      const touch = e.touches[0];
      this.startX = touch.clientX;
      this.startY = touch.clientY;
      this.deltaX = 0;
      this.isHorizontal = false;
      this.closeAllPopovers();
    },

    onTouchMove(e) {
      const touch = e.touches[0];
      const deltaX = touch.clientX - this.startX;
      const deltaY = touch.clientY - this.startY;

      // 还没确定方向时，先判断
      if (!this.isHorizontal) {
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
          this.isHorizontal = true; // 横向滑动
        } else {
          return; // 纵向滑动，直接放行
        }
      }

      // 只有横向滑动才阻止默认滚动
      e.preventDefault();

      const max = this.itemWidth;
      this.deltaX = Math.max(Math.min(deltaX, max), -max);
      this.closeAllPopovers();
    },

    onTouchEnd() {
      if (!this.isHorizontal) return;

      if (Math.abs(this.deltaX) > this.itemWidth / 4) {
        this.currentIndex += this.deltaX < 0 ? 1 : -1;
      }

      this.deltaX = 0;
      this.isHorizontal = false;

      setTimeout(this.fixLoopIndex, 300);
      this.closeAllPopovers();
    },
    fixLoopIndex() {
      const len = this.imgList.length;

      if (this.currentIndex === len + 1) {
        this.isResetting = true;
        this.currentIndex = 1;
      }

      if (this.currentIndex === 0) {
        this.isResetting = true;
        this.currentIndex = len;
      }

      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.isResetting = false;
        });
      });
    },
    goTo(index) {
      this.currentIndex = index + 1;
    },
    checkDevice() {
      this.isMobile = window.innerWidth <= 1024; // 根据屏幕宽度判断
    },
    // 以下全是PC端相关
    async login() {
      // 简单的表单验证
      // if (!this.loginForm.username || !this.loginForm.password) {
      //   this.loginError = "请输入用户名和密码";
      //   return;
      // }

      // this.loginLoading = true;
      this.loginError = "";

      try {
        const response = await axios.post(
          "http://113.44.138.18:18001/api/pub/token/ssoAuthToken",
          {
            appId: "9y2025092414563547AF",
            authCode: "MPiyBVIO",
            orgOpenId: "b7e7d45631a645fe",
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000, // 10秒超时
          },
        );

        // 登录成功处理
        if (response.data.success) {
          console.log("登录成功:", response);
          // 保存token到localStorage或Vuex
          localStorage.setItem("authToken", response.data.token);
          localStorage.setItem("userInfo", JSON.stringify(response.data.user));

          // 关闭登录对话框
          this.loginDialog = false;

          // 重置表单
          this.loginForm.username = "";
          this.loginForm.password = "";

          // 提示登录成功
          this.$message.success("登录成功！");

          // 可以根据需要跳转页面或更新用户状态
          // this.$router.push('/dashboard');
        } else {
          this.loginError = response.data.message || "登录失败";
        }
      } catch (error) {
        console.error("登录错误:", error);

        if (error.response) {
          // 服务器返回错误状态码
          switch (error.response.status) {
            case 401:
              this.loginError = "用户名或密码错误";
              break;
            case 404:
              this.loginError = "登录接口不存在";
              break;
            case 500:
              this.loginError = "服务器内部错误";
              break;
            default:
              this.loginError = "登录失败，请稍后重试";
          }
        } else if (error.request) {
          // 请求发出但没有收到响应
          this.loginError = "网络错误，请检查网络连接";
        } else {
          // 其他错误
          this.loginError = "登录过程中发生错误";
        }
      } finally {
        this.loginLoading = false;
      }
    },
    handleClose() {
      this.loginDialog = false;
    },
    toLoginEamil() {
      this.loginDialog = true;
    },
    handleFooterClick(link, item) {
      console.log("handleFooterClick", link, item);
      if (link.section) {
        this.scrollToSection(link.section);
      }
    },
    checkDevelopmentVisibility() {
      if (this.developmentAnimated) return;

      const developmentBlock = this.$refs.developmentBlock;
      if (!developmentBlock) return;

      const rect = developmentBlock.getBoundingClientRect();
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

      // 当发展历程区块进入视口时触发动画
      if (rect.top <= windowHeight * 0.8 && rect.bottom >= 0) {
        this.developmentAnimated = true;

        // 为每个发展历程项添加动画类
        this.developmentList.forEach((_, index) => {
          const items = this.$refs[`devItem${index}`];
          if (items && items[0]) {
            items[0].classList.add("animate-in");
          }
        });
      }
    },
    toggle4(index) {
      this.block4Index = index;
    },
    setActiveDistribution(index) {
      this.activeDistributionIndex = index;
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });

        this.activeIndex = sectionId;
      }
    },
    setActiveBusiness(index) {
      this.activeBusiness = index;
    },
    setSlide(index) {
      this.currentSlide = index;
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.bannerList.length;
    },
    prevSlide() {
      this.currentSlide =
        (this.currentSlide - 1 + this.bannerList.length) %
        this.bannerList.length;
    },
    startAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
      }
      this.autoPlayInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    pauseAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    },
    handleScroll() {
      const homeSection = document.getElementById("home");
      if (homeSection) {
        const rect = homeSection.getBoundingClientRect();
        this.isHomeSection = rect.bottom - 180 > 0;
      }

      const sections = document.querySelectorAll(
        ".block1, .block2-middle-box, .block2-box, .block3-box, .block4-box, .block5-box, .block6-box, .block7-box, .block8-box",
      );
      let currentSection = "home";

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;

        if (
          window.pageYOffset >= sectionTop - 120 &&
          window.pageYOffset < sectionTop + sectionHeight - 120
        ) {
          currentSection = section.id;
        }
      });

      this.activeIndex = currentSection;
    },
  },
};
</script>

<!-- PC端 -->
<style scoped>
/* 导航栏样式 */
.title-box {
  position: fixed;
  width: 100%;
  /* padding-top: 45px; */
  z-index: 10;
  transition: all 0.4s ease;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title-box.scrolled {
  background-color: #69a5ff;
  /* padding-top: 20px; */
  /* padding-bottom: 20px; */
}

.logo-img {
  width: 180px;
  height: 37px;
}

.title {
  display: flex;
  padding-left: 135px;
  padding-right: 135px;
  justify-content: space-between;
  align-items: center;
}

.title-nav {
  display: flex;
  color: #fff;
  width: 920px;
}

.title-nav-item:hover {
  color: #3775ff;
}

.title-nav-item.active {
  color: #3775ff;
  border-bottom: 2px solid #3775ff;
}
.block1 {
  height: 1080px;
  padding-left: 135px;
  padding-right: 135px;
  background-image: url("../assets/home-bg.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}
.title {
  display: flex;
  padding-left: 135px;
  padding-right: 135px;
  justify-content: space-between;
  align-items: center;
}
.title-text {
  color: #fff;
  font-size: 28px;
  font-weight: bold;
}
.title-nav {
  display: flex;
  color: #fff;
  width: 940px;
  justify-content: space-between;
}
.title-nav-item {
  cursor: pointer;
  font-size: 24px;
  height: 80px;
  border-bottom: 2px;
  padding: 0 10px;
  display: flex;
  align-items: center;
}
.active {
  color: #549ffe;
}
.active-b {
  color: #fff !important;
  border-bottom: 2px solid #fff !important;
}
/* 轮播图样式 */
.swiper-box {
  position: relative;
  width: 50%;
  height: 600px;
  overflow: hidden;
}
.swiper-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.swiper-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.8s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.swiper-item.active {
  opacity: 1;
}
.swiper-item-title {
  font-size: 76px;
  color: #fff;
  font-weight: bold;
  margin-bottom: 54px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}
.swiper-item-text {
  font-size: 48px;
  color: #fff;
  font-weight: bold;
  max-width: 650px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* 分页指示器 */
.pagination {
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.pagination-item {
  width: 48px;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.5);
  margin-right: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.pagination-item.active {
  background-color: #549ffe;
}

/* 导航按钮 */
.swiper-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.3);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.3s;
  z-index: 5;
}
.swiper-button:hover {
  background-color: rgba(0, 0, 0, 0.6);
}
.swiper-button.prev {
  left: 20px;
}
.swiper-button.next {
  right: 20px;
}
.block2-middle-box {
  width: 100%;
  height: 158px;
  margin-top: -79px;
  display: flex;
  justify-content: center;
  margin-bottom: 75px;
}
.block2-middle {
  width: 1200px;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  display: flex;
  justify-content: space-around;
  padding-left: 90px;
  padding-right: 90px;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);
}
.block2-item {
  display: flex;
  align-items: center;
}
.block2-icon {
  width: 96px;
  height: 104px;
  margin-right: 15px;
}
.block2-text-box {
  height: 118px;
}
.block2-text-title {
  font-size: 20px;
  margin-bottom: 8px;
}
.block2-text {
  font-size: 16px;
  max-width: 320px;
}
.block2-box {
  display: flex;
  justify-content: center;
}
.block2 {
  width: 1200px;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: center;
}
.block2-title {
  font-size: 32px;
  /* font-weight: bold; */
  text-align: center;
  color: #000000;
}
.block2-en-title {
  color: #707070;
  font-size: 20px;
  text-align: center;
  /* font-weight: bold; */
  margin-bottom: 10px;
}
.block2-1-text {
  color: #666666;
  font-size: 20px;
  text-align: center;
}
.block2-business-box {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 78px;
}

/* 业务项通用样式 */
.business-item {
  transition: all 0.3s ease;
  cursor: pointer;
}

/* 默认状态（收缩状态） */
.business-recruit {
  background-image: url("../assets/business/recruit.png");
  background-size: cover;
  width: 170px;
  height: 348px;
}
.business-smo {
  background-image: url("../assets/business/smo.png");
  background-size: cover;
  width: 170px;
  height: 348px;
}
.business-cro {
  background-image: url("../assets/business/cro.png");
  background-size: cover;
  width: 170px;
  height: 348px;
}
.business-pay {
  background-image: url("../assets/business/pay.png");
  background-size: cover;
  width: 170px;
  height: 348px;
}

/* 展开状态（带bg的样式） */
.business-recruit-bg {
  background-image: url("../assets/business/recruit-bg.png");
  background-size: cover;
  width: 628px;
  height: 348px;
}
.business-smo-bg {
  background-image: url("../assets/business/smo-bg.png");
  background-size: cover;
  width: 628px;
  height: 348px;
}
.business-cro-bg {
  background-image: url("../assets/business/cro-bg.png");
  background-size: cover;
  width: 628px;
  height: 348px;
}
.business-pay-bg {
  background-image: url("../assets/business/pay-bg.png");
  background-size: cover;
  width: 628px;
  height: 348px;
}
.business-title {
  margin-top: 55px;
  margin-left: 20px;
  padding-bottom: 13px;
  font-size: 24px;
  color: #fff;
}
.business-title-b {
  margin-top: 55px;
  margin-left: 20px;
  padding-bottom: 13px;
  font-size: 24px;
  color: #2247a6;
}
.business-text {
  padding-top: 40px;
  padding-left: 20px;
  padding-right: 50px;
  font-size: 20px;
  color: #fff;
}
.business-line {
  width: 40px;
  margin-left: 20px;
  border-bottom: 2px solid #fff;
}
.business-line-b {
  width: 20px;
  margin-left: 20px;
  border-bottom: 2px solid #2247a6;
}
.block3-box {
  width: 100%;
  background-color: #f5f9ff;
  display: flex;
  justify-content: center;
}
.block3 {
  width: 1200px;
  display: flex;
  flex-direction: column;
  padding-top: 33px;
  padding-bottom: 80px;
}
.block3-title {
  width: 100%;
  font-size: 32px;
  color: #000000;
  text-align: center;
  /* font-weight: bold; */
}
.block3-en-title {
  color: #707070;
  font-size: 20px;
  text-align: center;
  /* font-weight: bold; */
  margin-bottom: 38px;
}
.full-box {
  width: 100%;
  height: 530px;
  background-image: url("../assets/distribution/full-bg.png");
  background-size: cover;
  display: flex;
}
.full-box-left {
  width: 350px;
  height: 530px;
  background-image: url("../assets/distribution/left-full-bg.png");
  background-size: cover;
}
.block3-left-item {
  width: 350px;
  height: 156px;
  background-image: url("../assets/distribution/left-item-bg.png");
  background-size: cover;
}
.block3-left-item:first-child {
  margin-top: 80px;
}
.block3-left-item-no-bg {
  width: 350px;
  height: 100px;
}
.block3-left-item-right-bg {
  height: 100%;
  background-image: url("../assets/distribution/recruit-bg.png");
  background-size: 151px 150px;
  background-position: right;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 35px;
  padding-right: 12px;
}
.block3-left-item-right-no-bg {
  height: 100px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 35px;
  padding-right: 12px;
}
.block3-left-item-right-title-no-active {
  font-size: 12px;
  color: #333333;
  font-weight: bold;
}
.full-box-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* 动画效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 左侧业务项样式 */
.block3-left-item {
  transition: all 0.3s ease;
  height: 100px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.block3-left-item.active {
  height: 156px;
  background-image: url("../assets/distribution/left-item-bg.png");
  background-size: cover;
}

.block3-left-item.no-bg {
  background: none;
}

.block3-left-item-content {
  padding: 15px 35px 15px 35px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: c;
  height: 100%;
}

.block3-left-item-content.with-bg {
  background-image: url("../assets/distribution/recruit-bg.png");
  background-position: right;
  background-repeat: no-repeat;
  background-size: 151px 150px;
}

.block3-left-item-right-title {
  color: #2247a6;
  font-size: 20px;
  /* font-weight: bold; */
  transition: all 0.3s ease;
}

.block3-left-item.active .block3-left-item-right-title {
  color: #2247a6;
  font-size: 20px;
}

.block3-left-item.no-bg .block3-left-item-right-title {
  font-size: 20px;
  color: #333333;
}

.block3-left-item-right-en-title {
  font-size: 16px;
  color: #666666;
  /* font-weight: bold; */
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

.block3-left-item.active .block3-left-item-right-en-title {
  margin-bottom: 16px;
}

.block3-left-item-right-text {
  font-size: 14px;
  color: #666666;
  /* font-weight: bold; */
}

.block3-line {
  width: 100%;
  height: 1px;
  background-color: #dedede;
  margin: 10px 0;
}

/* 右侧地图区域样式 */
.block3-right-item {
  display: flex;
  padding-left: 61px;
  justify-content: space-around;
  align-items: center;
}

.block3-right-item-img {
  width: 554px;
  height: 399px;
  margin-right: 21px;
}

.area-section {
  margin-bottom: 10px;
}

.block3-right-item-title {
  font-size: 20px;
  /* font-weight: bold; */
}

.block3-right-item-content {
  font-size: 16px;
  /* font-weight: bold; */
  margin-bottom: 20px;
  margin-right: 15px;
  color: #555555;
}
.block4-box {
  display: flex;
  justify-content: center;
}
.block4 {
  width: 1200px;
  /* height: 868px; */
  padding-top: 72px;
  padding-bottom: 72px;
}
.block4-title-box {
  display: flex;
  justify-content: space-between;
  /* padding-top: 72px; */
  cursor: pointer;
}
.block4-title {
  font-size: 32px;
  color: #999999;
  /* font-weight: bold; */
  text-align: center;
}
.block4-title-en {
  font-size: 20px;
  color: #707070;
  /* font-weight: bold; */
  margin-bottom: 14px;
}
.block4-title-line {
  width: 60px;
  height: 4px;
  background-color: #3775ff;
}
.block4-title-line-box {
  width: 100%;
  display: flex;
  justify-content: center;
}
.block4-title-full-line {
  width: 100%;
  height: 2px;
  background-color: #ebebeb;
  margin-bottom: 20px;
}
.block4-img {
  width: 1200px;
}
.block4-title-active {
  color: #3775ff;
}
.block5-box {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f9ff;
  padding-top: 40px;
  padding-bottom: 80px;
}
.block5 {
  width: 1200px;
}
.block5-title {
  font-size: 32px;
  color: #000000;
  text-align: center;
  /* font-weight: bold; */
}
.block5-en-title {
  color: #707070;
  font-size: 20px;
  text-align: center;
  /* font-weight: bold; */
  margin-bottom: 14px;
}
.block5-title-tips {
  font-size: 20px;
  text-align: center;
  /* font-weight: bold; */
  margin-bottom: 28px;
  color: #666666;
}

.block5-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
/* 原有样式保持不变 */
.block5-item-img-big {
  width: 882px;
  height: 480px;
  transition: all 0.4s ease;
}

.block5-item-img-small {
  width: 300px;
  height: 480px;
  cursor: pointer;
  transition: all 0.4s ease;
}

/* 新增动画样式 */
.block5-item-left,
.block5-item-right {
  overflow: hidden;
  transition: all 0.4s ease;
}

/* 左侧激活时的样式 */
.block5-item-left.active {
  width: 882px;
}

.block5-item-right.inactive {
  width: 300px;
}

/* 右侧激活时的样式 */
.block5-item-right.active {
  width: 882px;
  margin-left: -582px; /* 向左移动 (882-300)px */
}

.block5-item-left.inactive {
  width: 300px;
}
.block6-box {
  display: flex;
  justify-content: center;
  padding-top: 53px;
  padding-bottom: 80px;
  /* background-color: #f5f9ff; */
}
.block6 {
  width: 1200px;
}
.block6-title {
  font-size: 32px;
  /* font-weight: bold; */
  color: #000000;
  text-align: center;
}
.block6-en-title {
  font-size: 24px;
  color: #707070;
  text-align: center;
  /* font-weight: bold; */
}
.block6-content {
  width: 1200px;
  height: 546px;
  background-image: url("../assets/development.png");
  background-size: cover;
  position: relative;
}

/* 发展历程项初始状态 - 隐藏在顶部 */
.block6-item {
  font-size: 20px;
  /* font-weight: bold; */
  width: 217px;
  opacity: 0;
  transform: translateY(-100px);
  transition: opacity 0.8s ease,
    transform 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: absolute;
}

/* 发展历程项最终状态 - 降落到预定位置 */
.block6-item.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* 各发展历程项的位置 */
.block6-item1 {
  bottom: 286px;
  left: 93px;
  transition-delay: 0.1s;
}

.block6-item2 {
  bottom: 353px;
  left: 334px;
  transition-delay: 0.3s;
}

.block6-item3 {
  right: 377px;
  bottom: 395px;
  transition-delay: 0.5s;
}

.block6-item4 {
  right: 104px;
  bottom: 465px;
  transition-delay: 0.7s;
}
.block7-box {
  display: flex;
  justify-content: center;
  padding-top: 34px;
  padding-bottom: 80px;
  background-color: #f5f9ff;
}
.block7 {
  width: 1200px;
}
.block7-title {
  font-size: 32px;
  /* font-weight: bold; */
  color: #000000;
  text-align: center;
}
.block7-en-title {
  font-size: 24px;
  color: #707070;
  text-align: center;
  /* font-weight: bold; */
  margin-bottom: 22px;
}
.block7-img {
  width: 100%;
}
.block8-box {
  display: flex;
  justify-content: center;
  padding-top: 34px;
  padding-bottom: 80px;
}
.block8 {
  width: 1200px;
}
.block8-title {
  font-size: 32px;
  color: #000000;
  text-align: center;
}
.block8-en-title {
  font-size: 20px;
  color: #707070;
  text-align: center;
  margin-bottom: 14px;
}
.block8-desc {
  font-size: 20px;
  color: #666666;
  text-align: center;
  margin-bottom: 28px;
}
.block8-card {
  background-color: #fafcff;
  border-radius: 8px;
  overflow: hidden;
  min-height: 700px;
  position: relative;
}
.block8-card-header {
  background-color: #065fd4;
  border-radius: 0 8px 8px 0;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  font-weight: 500;
}
.block8-card-body {
  padding: 20px 47px 30px 47px;
}
.block8-section {
  display: grid;
  grid-template-columns: 40px 1fr;
  align-items: start;
  margin-top: 20px;
  margin-bottom: 10px;
}
.block8-section-icon {
  width: 26px;
  height: 26px;
  background-color: #dbeafe;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}
.block8-section-icon-img {
  width: 14px;
  height: 14px;
}
.block8-section-right {
  display: flex;
  justify-content: flex-start;
}
.block8-section-title {
  min-width: 100px;
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  padding-left: 5px;
  margin-right: 30px;
}
.block8-section-content {
  font-size: 20px;
  color: #333333;
  line-height: 1.8;
  padding-left: 10px;
}
.block8-pagination {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  gap: 12px;
}
.block8-pagination-item {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ddd;
  cursor: pointer;
  transition: all 0.3s;
}
.block8-pagination-item.active {
  background-color: #3775ff;
  transform: scale(1.2);
}
.footer-box {
  display: flex;
  justify-content: center;
  padding-top: 50px;
  padding-bottom: 60px;
  background-color: #050f19;
}
.footer {
  width: 1200px;
}
.footer-up {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.footer-item {
  color: #fff;
}
.qrcode {
  width: 133px;
  height: 133px;
}
.fotter-item-title {
  font-size: 20px;
  margin-bottom: 27px;
  /* font-weight: bold; */
}
.footer-item-content div {
  font-size: 16px;
  /* font-weight: bold; */
  margin-bottom: 15px;
  cursor: pointer;
}
.footer-item-content-item {
  display: flex;
}
.address {
  max-width: 250px;
}
.footer-line {
  width: 100%;
  height: 1px;
  background: #293a49;
  margin-top: 58px;
  margin-bottom: 62px;
}
.footer-down {
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: #748ea6;
  cursor: pointer;
}
.login-email-btn-box {
  position: fixed;
  right: 0;
  bottom: 10%;
  height: 137px;
  width: 77px;
  background: #fff;
  border-radius: 40px;
  box-shadow: -3px 4px 3px 0px rgba(48, 89, 232, 0.2);
  cursor: pointer;
}
.email-btn {
  height: 79px;
  width: 79px;
}
.email-text {
  font-size: 16px;
  text-align: center;
}
.el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-dialog__wrapper ::v-deep .login-dialog .el-dialog__body {
  padding: 33px 48px !important;
}
.el-dialog__wrapper ::v-deep .login-dialog {
  height: 800px !important;
  margin-top: 0 !important;
  background-image: url("../assets/dialog-bg.png");
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-dialog__wrapper ::v-deep .el-dialog__header {
  /* display: none !important; */
}
.login-dialog-logo {
  width: 199px;
  height: 49px;
}
.login-dialog-title-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dialog-title {
  font-size: 24px;
  color: #000000;
  margin-top: 54px;
  margin-bottom: 20px;
}
.dialog-vice-title {
  font-size: 20px;
  color: #999999;
  margin-bottom: 33px;
}
.login-dialog-input-box {
  width: 600px;
}
</style>
<!-- 移动端 -->
<style scoped>
* {
  -webkit-tap-highlight-color: transparent;
}
.mobile-warp {
  background-color: #fff;
  overflow-x: hidden;
}
.mobile-warp::-webkit-scrollbar {
  width: 0;
}
.block1-mobile {
  height: 246px;
  background-image: url("../assets/mobile/swiper-bg-1.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;
}
.logo-box-mobile {
  height: 50px;
  background-color: #fff;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  padding-top: 13px;
  padding-left: 15px;
  padding-right: 15px;
  z-index: 999;
  box-sizing: border-box; /* 新增这行 */
}
.home-top {
  height: 50px;
}
.logo-mobile {
  height: 24px;
}
.drawer-img {
  width: 22px;
  height: 22px;
}
/* 轮播图样式 */
.swiper-box-mobile {
  position: relative;
  width: 100%;
  height: 246px;
  overflow: hidden;
}
.swiper-container-mobile {
  position: relative;
  width: 70%;
  height: 100%;
}
.swiper-item-mobile {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 65%;
  opacity: 0;
  transition: opacity 0.8s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.swiper-item-mobile.active {
  opacity: 1;
}
.swiper-item-title-mobile {
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  margin-bottom: 3px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}
.swiper-item-text-mobile {
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  max-width: 650px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}
/* 分页指示器 */
.pagination-mobile {
  width: 100%;

  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 85px;
  left: 0;
  right: 0;
}
.pagination-item-mobile {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  margin-right: 8px;
  background-color: #fff;
  cursor: pointer;
  transition: background-color 0.3s;
}
.pagination-item-mobile.active {
  background-color: #549ffe;
}
.block2-mobile {
  padding: 20px 15px 16px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  margin-top: -70px;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 6px;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);
}
.block2-mobile-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.block2-img {
  width: 33px;
  height: 36px;
}
.block2-title {
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 6px;
}
.block2-text {
  font-size: 12px;
  color: #666666;
  text-align: center;
}
.block3-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 20px;
}
.block3-mobile-title {
  font-size: 16px;
  margin-bottom: 3px;
  text-align: center;
}
.block3-mobile-subtitle {
  font-size: 12px;
  color: #999999;
  margin-bottom: 9px;
}
.block3-mobile-description {
  font-size: 12px;
  color: #666666;
  text-align: center;
}
.block3-mobile-item-box {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-top: 12px;
}
.block3-mobile-item {
  background-size: 100% 100%;
  height: 110px;
  border-radius: 4px;
  padding: 12px 15px;
  box-sizing: border-box;
}
.block3-mobile-item-1 {
  background-image: url("../assets/mobile/business-1.png");
}
.block3-mobile-item-2 {
  background-image: url("../assets/mobile/business-2.png");
}
.block3-mobile-item-3 {
  background-image: url("../assets/mobile/business-3.png");
}
.block3-mobile-item-4 {
  background-image: url("../assets/mobile/business-4.png");
}
.block3-mobile-item-title {
  font-size: 14px;
}
.block3-mobile-item-line {
  width: 15px;
  height: 2px;
  background-color: #2247a6;
  margin-top: 4px;
  margin-bottom: 4px;
  border-radius: 6px;
}
.block3-mobile-item-text {
  font-size: 11px;
  color: #666666;
}
.block4-mobile {
  background-color: #f5f9ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.mobile-carousel {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding-left: 15px;
}
.carousel-viewport {
  padding-left: 15px;
  overflow: hidden;
}

.carousel-inner {
  display: flex;
  gap: 15px;
  will-change: transform;
}

.carousel-item {
  width: calc(100vw - 45px);
  flex-shrink: 0;
  box-sizing: border-box;
}
.distribution-item-box {
  background-image: url("../assets/mobile/distribution-bg.png");
  background-size: 100% 100%;
  padding: 15px;
  min-height: 350px;
}
.distribution-item-title {
  font-size: 14px;
  margin-bottom: 5px;
}
.distribution-item-subtitle {
  font-size: 12px;
  margin-bottom: 5px;
  color: #999999;
}
.distribution-item-description {
  font-size: 12px;
  color: #666666;
}
.distribution-item-map-box {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 10px;
}
.distribution-item-map {
  width: 226px;
}
.distribution-item-point-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 13px;
  font-size: 12px;
}
.distribution-item-point-box-last {
  margin-bottom: 0;
}
.distribution-item-point-box div {
  display: flex;
  flex: 1;
  justify-content: flex-start;
}
.distribution-item-point {
  color: #505050;
}
.distribution-img {
  width: 100%;
  height: auto;
  aspect-ratio: 330 / 375;
  border-radius: 8px;
  object-fit: contain;
  background: #fff;
}

/* 指示点 */
.carousel-indicators {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 12px;
  margin-bottom: 5px;
}

.indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ddd;
  transition: all 0.3s;
}

.indicator.active {
  background-color: #007aff;
  transform: scale(1.2);
}
.carousel-end-holder {
  width: 30px;
  margin-right: 0;
  flex-shrink: 0;
}
.block5-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  /* padding-bottom: 20px; */
}
.block5-mobile-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.block5-mobile-tabs-item {
  width: 33.3%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.block5-mobile-tabs-item-title {
  font-size: 14px;
  margin-bottom: 4px;
}
.block5-mobile-tabs-item-down-line {
  width: 30px;
  height: 2px;
  background-color: #fff;
  border-radius: 2px;
}
.block5-mobile-tabs-item .title-active {
  color: #307aea;
}
.block5-mobile-tabs-item .line-active {
  background-color: #307aea;
}
.introduction-img {
  width: 100%;
}
.intro-item-box {
  background-image: url("../assets/mobile/introduction-bg.png");
  background-size: 100% 100%;
  padding: 15px;
}
.intro-item-3-box {
  padding: 25px;
}
.intro-item-1st {
  font-size: 12px;
  color: #666666;
  margin-bottom: 10px;
}
.intro-item-title {
  font-size: 14px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.intro-item-1-dis {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 15px;
}
.intro-item-1-item {
  flex: 1;
  background-image: url("../assets/mobile/introduction-1-item.png");
  background-size: 100% 100%;
  padding: 10px;
  margin-bottom: 10px;
}
.intro-item-1-item-title {
  font-size: 14px;
  margin-bottom: 4px;
}
.intro-item-1-item-text {
  font-size: 12px;
  color: #666666;
}
.intro-item-bottom-title-box {
  position: relative;
  margin-bottom: 10px;
}
.intro-item-bottom-title {
  font-size: 12px;
}
.intro-item-bottom-line {
  position: absolute;
  bottom: 2px;
  width: 51px;
  height: 2px;
  background-color: rgba(67, 126, 255, 0.4);
}
.intro-item-1-img {
  width: 100%;
}
.intro-item-2-img {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.intro-item-bottom-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.intro-icon-box {
  width: 12px;
  margin-right: 5px;
}
.intro-icon-img {
  width: 100%;
}
.intro-item-bottom-item-text {
  font-size: 12px;
}
.intro-item-bottom-item-text-large {
  font-size: 10px;
  color: #999999;
  margin-bottom: 10px;
}
.block6-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 20px;
  background-color: #f5f9ff;
}
.solu-item {
  width: calc(100% - 30px);
  padding: 15px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.solu-line {
  width: 20px;
  height: 2px;
  background-color: #65a7ff;
  border-radius: 6px;
  margin-top: 5px;
  margin-bottom: 10px;
}
.solu-text-box {
  display: flex;
  justify-content: space-between;
  text-align: left;
  margin-bottom: 5px;
}
.solu-text-box div {
  width: 50%;
  font-size: 11px;
  color: #666666;
}
.solu-text {
  font-size: 12px;
  color: #666666;
}
.solu-item-title-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.rec-title-icon-img {
  width: 14px;
  margin-right: 5px;
}
.solu-item-title {
  font-size: 14px;
}
.operation-img {
  width: 100%;
  margin-top: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.block7-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  background-image: url("../assets/mobile/block-7-bg.png");
  background-size: 100% 100%;
}
.time-line-box {
  width: 100%;
  margin-top: 10px;
}
.time-line-box ::v-deep .el-timeline {
  padding-left: 15px;
}
.time-line-box ::v-deep .el-timeline-item__wrapper {
  top: -5px;
  padding-left: 15px;
}
.time-line-box ::v-deep .el-timeline-item__node {
  width: 10px;
  height: 10px;
}

.time-line-box ::v-deep .el-timeline-item__tail {
  left: 3px;
}

.block8-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.block9-mobile {
  background-color: #050f19;
  padding-top: 11px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 20px;
}
.block10-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #fafcff;
}
.block10-mobile-desc {
  font-size: 12px;
  color: #666666;
  text-align: center;
  margin-bottom: 12px;
}
.block10-mobile-section {
  display: flex;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 6px;
}
.block10-mobile-section-icon {
  width: 20px;
  height: 20px;
  background-color: #dbeafe;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  flex-shrink: 0;
}
.block10-mobile-section-title {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
.block10-mobile-section-content {
  font-size: 12px;
  color: #333333;
  line-height: 1.6;
}
.block10-mobile-item {
  margin-bottom: 4px;
}
.block10-mobile-accordion {
  width: 100%;
}
.block10-mobile-accordion-item {
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.block10-mobile-accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  cursor: pointer;
  background: transparent;
  border: none;
  border-radius: 0 0 6px 6px;
}
.block10-mobile-accordion-title {
  font-size: 14px;
  font-weight: 500;
  color: #065FD4;
  text-align: center;
  flex: 1;
}
.block10-mobile-accordion-icon {
  width: 14px;
  height: 14px;
}
.block10-mobile-accordion-body {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  padding: 0 15px;
}
.block10-mobile-accordion-body.is-open {
  max-height: 2000px;
  padding: 12px 15px 15px 15px;
  border-top: 1px solid #EDEDED;
}
.menu-line {
  width: 100%;
  height: 1px;
  background-color: #748ea6;
  margin-top: 20px;
  margin-bottom: 20px;
}
.copyright-text {
  color: #748ea6;
  width: 100%;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
}
.menu-box {
  display: flex;
  justify-content: space-between;
}
.menu-item {
  width: 40%;
}

.menu-title {
  font-size: 14px;
  color: #fff;
  margin-bottom: 10px;
}
.menu-text {
  font-size: 10px;
  color: #fff;
  margin-bottom: 10px;
}
.qrcode-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}
.qrcode-img {
  width: 54px;
  height: 54px;
  margin-right: 30px;
}
.drawer-custom-class {
  width: 300px;
}
.drawer-box {
  padding: 15px;
}
.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}
.close-icon {
  display: block;
}
.drawer-content {
}
.drawer-long-line {
  width: 100%;
  height: 1px;
  background-color: #d9d9d9;
  margin: 12px 0;
}
.link-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
}
.link-item-inner {
  padding-left: 10px;
}
.link-item-inner-text {
  font-size: 14px;
}
.link-item-inner-line {
  width: 100%;
  height: 1px;
  background-color: #d9d9d9;
  margin: 12px 0;
}
.link-item-inner {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.link-item-inner.open {
  max-height: 300px; /* 足够大即可 */
}
::v-deep .img-dialog-box .el-dialog__header {
  display: none;
}

::v-deep .img-dialog-box .el-dialog__body {
  padding: 0;
}

.img-dialog {
  width: 100%;
}

.dialog-img {
  display: block;
  width: 100%;
  height: auto;
}
.popover-ref {
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.mobile-popover {
  position: fixed !important;
}
</style>
